import * as React from 'react';
import ErrorAlert from './ErrorAlert';
import Spinner from './Spinner';

/**
 * Error alert component that shows error information on the front end.
 *
 * @class Loading
 * @extends {React.Component<any>}
 */
class Loading extends React.Component<any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { error, retry, timedOut, pastDelay } = this.props;

		if (error) {
			// react-loadable seems to swallow these errors, which isn't great.
			// let's spit them out if there's something.
			console.error(error);
			return <ErrorAlert error={(error as Error) || null} />;
		} else if (timedOut) {
			return (
				<div>
					Taking a long time... <button onClick={retry}>Retry</button>
				</div>
			);
		} else if (pastDelay) {
			return (
				<div className="loading">
					<Spinner />
				</div>
			);
		} else {
			return null;
		}
	}
}

export default Loading;
